export default {
      id: "arrow-square-out-bold-usage",
      viewBox: "0 0 38 39",
      url: __webpack_public_path__ + "sprite.svg#arrow-square-out-bold",
      toString: function () {
        return this.url;
      }
    }